import React, { useState, useEffect } from "react";
// import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
// Redux
import { useSelector } from "react-redux";
// Constants - Functions
import { pathHomePage, WEB_SERVICE_MIMS } from "../../../../config/constants";
import { handleSetDurationFromDB, isARProtocol, isProtocolWithoutDuration } from "../../../../config/functions";
// Components
import {
  PrescriptionDiv,
  ProtocolCardDiv,
  ProtocolImgAndNameDiv,
  ProtocolImg,
  ProtocolName,
  ShowPrescriptionsButton,
  ArrowImg,
  FlexDiv,
  ExtraInfoDiv,
  ExtraInfoText,
  DurationSelect,
  ReportsSectionDiv,
  SessionsDiv,
  ReportsLink,
  ReportsImg,
  SessionsNumber,
} from "./styles";
import Axios from "../../../../config/axios";
// Assets
import IcoArrowUp from "../../../../assets/ico_arrow_up.svg";
import IcoArrowDown from "../../../../assets/ico_arrow_down.svg";
import ReportsIco from "../../../../assets/ico_reports.svg";

const ProtocolPrescription = ({
  protocolImg,
  protocolName,
  prescriptions,
  isDisabledInputs,
  prescriptionsToDatabase,
  protocolId,
  patientId,
  software,
}) => {
  const [monday, setMonday] = useState(false);
  const [tuesday, setTuesday] = useState(false);
  const [wednesday, setWednesday] = useState(false);
  const [thursday, setThursday] = useState(false);
  const [friday, setFriday] = useState(false);
  const [saturday, setSaturday] = useState(false);
  const [sunday, setSunday] = useState(false);
  const [bonus, setBonus] = useState(false);
  const [duration, setDuration] = useState(5);
  const [sessionsNumber, setSessionsNumber] = useState(0);
  const [isShowPrescriptions, setIsShowPrescriptions] = useState(false);

  const clinicianToken = useSelector(({ clinician }) => clinician.data.token);
  const [t] = useTranslation("global");

  // Fetching protocol sessions
  useEffect(() => {
    Axios("get", `${WEB_SERVICE_MIMS}/patients/sessions/get/${patientId}/${protocolId}/${software}`)
      .then(({ data }) => {
        setSessionsNumber(data);
      })
      .catch((error) => {
        console.log("url error: ", error);
      });
  }, [patientId, protocolId, software]);

  // Setting prescription days
  useEffect(() => {
    if (prescriptions) {
      prescriptions.forEach((prescription) => {
        switch (prescription.WEEKDAY) {
          case "MONDAY":
            setMonday(true);
            setDuration(handleSetDurationFromDB(prescription));
            break;
          case "TUESDAY":
            setTuesday(true);
            setDuration(handleSetDurationFromDB(prescription));
            break;
          case "WEDNESDAY":
            setWednesday(true);
            setDuration(handleSetDurationFromDB(prescription));
            break;
          case "THURSDAY":
            setThursday(true);
            setDuration(handleSetDurationFromDB(prescription));
            break;
          case "FRIDAY":
            setFriday(true);
            setDuration(handleSetDurationFromDB(prescription));
            break;
          case "SATURDAY":
            setSaturday(true);
            setDuration(handleSetDurationFromDB(prescription));
            break;
          case "SUNDAY":
            setSunday(true);
            setDuration(handleSetDurationFromDB(prescription));
            break;
          case "BONUS":
            setBonus(true);
            setDuration(handleSetDurationFromDB(prescription));
            break;
          default:
            break;
        }
      });
    }
  }, [prescriptions]);

  const isClinicOrHome = () => software === "clinic" || software === "home";

  const handleShowPrescriptions = (e) => {
    e.preventDefault();
    setIsShowPrescriptions(!isShowPrescriptions);
  };

  const renderDurationOptions = () => {
    return Array.apply(null, { length: 10 }).map((e, i) => {
      i++;
      return (
        <option key={i} value={i}>
          {i} min
        </option>
      );
    });
  };

  const handleSetDurationDisabled = () => {
    if (isDisabledInputs) return true;
    return !monday && !tuesday && !wednesday && !thursday && !friday && !saturday && !sunday && !bonus;
  };

  const handleSetDuration = (min) => {
    setDuration(min);
    let activeDays = [];
    monday && activeDays.push("MONDAY");
    tuesday && activeDays.push("TUESDAY");
    wednesday && activeDays.push("WEDNESDAY");
    thursday && activeDays.push("THURSDAY");
    friday && activeDays.push("FRIDAY");
    saturday && activeDays.push("SATURDAY");
    sunday && activeDays.push("SUNDAY");
    bonus && activeDays.push("BONUS");
    return activeDays.map((day) => {
      const verifyPrescription = prescriptionsToDatabase.find(
        (prescription) => prescription.PROTOCOL_ID === protocolId && prescription.WEEKDAY === day
      );
      if (verifyPrescription) {
        return prescriptionsToDatabase.forEach((prescription) => {
          if (prescription.PROTOCOL_ID === protocolId && prescription.WEEKDAY === day) {
            prescription.SESSION_DURATION = Number(min) * 60;
            if (software === "app") {
              prescription.AR_MODE = isARProtocol(protocolId) ? "TABLE" : "NONE";
            }
          }
        });
      } else {
        let prescription = {
          PROTOCOL_ID: protocolId,
          WEEKDAY: day,
          STARTING_DATE: new Date(),
          ENDING_DATE: new Date("2100-01-01"),
          SESSION_DURATION: Number(min) * 60,
        };
        if (software === "app") {
          prescription.AR_MODE = isARProtocol(protocolId) ? "TABLE" : "NONE";
        }
        return prescriptionsToDatabase.push(prescription);
      }
    });
  };

  const renderProtocolCard = () => {
    const handleShowProtocolVideo = (e) => {
      e.preventDefault();
    };

    return (
      <ProtocolCardDiv>
        <ProtocolImgAndNameDiv onClick={handleShowProtocolVideo}>
          <ProtocolImg src={protocolImg} alt="protocol-img" />
          <ProtocolName>{protocolName}</ProtocolName>
        </ProtocolImgAndNameDiv>
        <ShowPrescriptionsButton onClick={handleShowPrescriptions}>
          <ArrowImg src={isShowPrescriptions ? IcoArrowUp : IcoArrowDown} alt="ico-arrow" />
        </ShowPrescriptionsButton>
      </ProtocolCardDiv>
    );
  };

  const getSessionsNumber = () => {
    if (sessionsNumber < 1) return "-";
    if (sessionsNumber > 99) return "+99";
    return sessionsNumber;
  };

  const renderProtocolDaysResponsive = () => {
    return (
      <ExtraInfoDiv show={isShowPrescriptions} isClinicOrHome={isClinicOrHome()}>
        <FlexDiv width="110px">
          <ExtraInfoText>{t("prescriptions.tableDurationText")}</ExtraInfoText>
          {isProtocolWithoutDuration(protocolId) ? (
            "-"
          ) : (
            <>
              <DurationSelect value={duration} onChange={(e) => handleSetDuration(e.target.value)} disabled={handleSetDurationDisabled()}>
                {renderDurationOptions()}
              </DurationSelect>
            </>
          )}
        </FlexDiv>
        <FlexDiv width="410px" />
        <FlexDiv width="120px" width910="95px">
          <ReportsSectionDiv>
            <ExtraInfoText>{t("prescriptions.tableReportsText")}</ExtraInfoText>
            <SessionsDiv>
              <ReportsLink
                sessions={sessionsNumber}
                to={`${pathHomePage}/reports/${clinicianToken}/${software}/${patientId}/${protocolId}`}
              >
                <ReportsImg src={ReportsIco} alt="reports-btn" />
              </ReportsLink>
              <SessionsNumber>{getSessionsNumber()}</SessionsNumber>
            </SessionsDiv>
          </ReportsSectionDiv>
        </FlexDiv>
      </ExtraInfoDiv>
    );
  };

  return (
    <>
      <PrescriptionDiv>
        {renderProtocolCard()}
        {renderProtocolDaysResponsive()}
      </PrescriptionDiv>
    </>
  );
};

export default ProtocolPrescription;
